import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import Content from './content';
import Actions from './actions';
const Root = styled('div')(({ theme, fill, center }) => (Object.assign(Object.assign({ display: 'flex', flexDirection: 'column', borderWidth: 1, borderStyle: 'dashed', borderSpacing: '10px 10px', borderColor: theme.palette.primary.main, padding: theme.spacing(2), borderRadius: theme.spacing(1), marginBottom: theme.spacing(4), '&:only-child': {
        marginBottom: 0,
    } }, (fill
    ? {
        height: '100%',
    }
    : {})), (center
    ? {
        justifyContent: 'center',
        alignItems: 'center',
        '& .content': {
            flexGrow: 0,
        },
    }
    : {}))));
const Title = styled(Typography)(({ theme }) => ({ marginBottom: theme.spacing(1) }));
const ReadOnlyBlock = ({ title, fill = false, center = false, gridSize = 12, items = [], components = [], actions = [], handleEdit, handleView }) => {
    const showActions = handleEdit || handleView || actions.length > 0;
    return (_jsxs(Root, Object.assign({ fill: +!!fill, center: +!!center }, { children: [title && _jsx(Title, Object.assign({ variant: "h5" }, { children: title })), _jsx(Content, { gridSize: gridSize, items: items, components: components }), showActions && _jsx(Actions, { actions: actions, handleEdit: handleEdit, handleView: handleView })] })));
};
export default ReadOnlyBlock;
//# sourceMappingURL=index.js.map